import React, { useState } from 'react';
import ViewPassword from '../../images/eye-icon.svg';
import HidePassword from '../../images/eye-off.svg';
import InputWithLabel from '../../components/shared/fields/InputWithLabel';
import Button from '../../components/shared/buttons/button';

import { showToast } from '../../helpers/Utils';
import { useChangePasswordMutation } from '../../app/userApi/userApi';

const ChangePassword = () => {
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const { oldPassword, newPassword, confirmPassword } = formData;

    if (!oldPassword || !newPassword || !confirmPassword) {
      showToast('All fields are required.', 'error');
      return;
    }

    if (newPassword !== confirmPassword) {
      showToast('New password and confirm password must match.', 'error');
      return;
    }

    try {
      const res = await changePassword({
        oldPassword,
        newPassword,
      }).unwrap();

      showToast(res?.message || 'Password changed successfully', 'success');

      // Optional: Reset form
      setFormData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    } catch (err) {
      console.log(err,"err");
      
      showToast(err?.data?.message || 'Failed to change password', 'error');
    }
  };

  return (
    <div className='col-md-6'>
      <h6 className='mb-0 setting-headings mb-3'>Change Password</h6>

      <div className="position-relative mb-3">
        <InputWithLabel
          label={'Old Password'}
          placeholder="Enter old password"
          type={showOld ? 'text' : 'password'}
          value={formData.oldPassword}
          onChange={(e) => handleChange('oldPassword', e.target.value)}
        />
        <span className="view_pass" onClick={() => setShowOld(!showOld)} style={{ cursor: 'pointer' }}>
          <img src={showOld ? ViewPassword : HidePassword} alt="toggle" className='mt-4' />
        </span>
      </div>

      <div className="position-relative mb-3">
        <InputWithLabel
          label={'New Password'}
          placeholder="Enter new password"
          type={showNew ? 'text' : 'password'}
          value={formData.newPassword}
          onChange={(e) => handleChange('newPassword', e.target.value)}
        />
        <span className="view_pass" onClick={() => setShowNew(!showNew)} style={{ cursor: 'pointer' }}>
          <img src={showNew ? ViewPassword : HidePassword} alt="toggle" className='mt-4' />
        </span>
      </div>

      <div className="position-relative mb-3">
        <InputWithLabel
          label={'Confirm Password'}
          placeholder="Re-enter new password"
          type={showConfirm ? 'text' : 'password'}
          value={formData.confirmPassword}
          onChange={(e) => handleChange('confirmPassword', e.target.value)}
        />
        <span className="view_pass" onClick={() => setShowConfirm(!showConfirm)} style={{ cursor: 'pointer' }}>
          <img src={showConfirm ? ViewPassword : HidePassword} alt="toggle" className='mt-4' />
        </span>
      </div>

      <Button label={isLoading ? 'Submitting...' : 'Submit'} onClick={handleSubmit} />
    </div>
  );
};

export default ChangePassword;
